module.exports = __webpack_public_path__ + "img/commandcenter_driving.7f2da0fb.svg";